import "./style/style";
import React from "react";
import { createRoot } from "react-dom/client";
import { getBuildId } from "./utils/utils";
import { ReportGenerationPage } from "./components/pages/report-generation/ReportGenerationPage";
import { setupLocale } from "services/lang/LanguageService";

const getQueryParam = (param: string): string | undefined => {
  const urlParams = new URLSearchParams(window.location.search);
  return urlParams.get(param) || undefined;
};

export default async function startEasasJsReports() {
  console.log("EASAS-JS reports bundle entry point...");
  console.log(`Auto CD Build ID: ${getBuildId()}`);

  const language = getQueryParam("language") || "en";

  await setupLocale({
    getLanguage: () => language,
    currentUser: undefined,
    isCurrentUserLoaded: false,
    setCompanyContext: () => {},
    setCurrentUser: () => {},
  });

  const rootEl = document.getElementById("root");
  const reactRoot = createRoot(rootEl as HTMLElement);
  const app = <ReportGenerationPage />;

  reactRoot.render(app);

  if (module.hot) {
    console.log("Accepting hot reload...");
    module.hot.accept();
  }
}

